<template>
	<div class="special-card">
		<div class="column column_text">
			<div class="title">
				<p v-html="title"></p>
        <p v-html="subTitle" class="subtitle"></p>
			</div>
		</div>
		<div class="column column_image under_display">
			<img :src="imageSp" alt=""/>
		</div>
		<div class="link_box">
			<div class="link-btn"><PageLinkButton :link="pageLink" /></div>
		</div>
		<div class="column column_image over_display">
			<img :src="image" alt=""/>
		</div>
	</div>
</template>

<script>
import PageLinkButton from '@/components/common/PageLinkButton.vue';
export default {
	name: 'special-card',
	components: {
		PageLinkButton,
	},
	props: {
		title: String,
		subTitle: String,
		image: String,
		imageSp: String,
		pageLink: String,
	},
};
</script>

<style lang="scss" scoped>
.special-card {
  width: 90%;
  max-width: 1080px;
	position: relative;
  margin: 100px auto;
  border: 2px solid #533488;
	background-color: #fff;
	display: flex;
	justify-content: center;
	flex-direction: column;
	@media print, screen and (min-width: 1161px) {
		height: 330px;
		flex-wrap: wrap;
	}
	@media print, screen and (max-width: 1160px) {
		height: auto;
		margin-bottom: 60px;
	}
}

.column_image {
	position: relative;
	overflow: hidden;
	@media print, screen and (min-width: 1161px) {
		width:680px;
	}
	@media print, screen and (max-width: 1161px) {
		width:100%;
	}
	img {
		height: auto;
    width:100%;
		vertical-align: middle;
	}
}
.column_text {
	position: relative;
	background-color: #fff;
	font-family: 'ots-mincho', serif;
	font-size: 17px;
	@media print, screen and (min-width: 1160px) {
		width: calc(100% - 680px);
	}
	@media print, screen and (max-width: 1160px) {
		padding: 30px 0 20px;
		width: 100%;
	}
	.title {
		position: relative;
		text-align: center;
		font-size: 36px;
		@media print, screen and (max-width: 1160px) {
			font-size: 20px;
		}
		p {
			margin: 0;
			line-height: 1.8em;
			letter-spacing: 0;
		}
		.subtitle{
			font-size: 0.75em;
		}
	}
}
.link_box{
	@media print, screen and (min-width: 1160px) {
		width: calc(100% - 680px);
		margin-top: 10px;
	}
	@media print, screen and (max-width: 1160px) {
		margin: 30px 0 40px;
	}
	.link-btn {
		width: 100%;
		text-align: center;
		@media print, screen and (min-width: 1161px) {
			font-size: 40px;
		}
	}
}
</style>
